import { useState, useCallback } from 'react';

const DEFAULT_FILTERS = {
  source: '',
  author: '',
  dateRange: '',
  customStartDate: '',
  customEndDate: '',
  limit: 10,
  offset: 0,
};

const buildFilters = (overrides = {}) => ({
  ...DEFAULT_FILTERS,
  ...overrides,
});

export const useFilters = (initialFilters = {}) => {
  const [filters, setFilters] = useState(() => buildFilters(initialFilters));

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => {
      const newFilters = {
        ...prev,
        [key]: value,
      };

      // Reset offset when changing other filters (but not when updating offset or limit)
      if (key !== 'offset' && key !== 'limit') {
        newFilters.offset = 0;
      }

      return newFilters;
    });
  }, []);

  const clearFilters = useCallback(() => {
    setFilters(buildFilters());
  }, []);

  const replaceFilters = useCallback((nextFilters = {}) => {
    setFilters((prev) => buildFilters({
      limit: prev.limit,
      ...nextFilters,
      offset: 0,
    }));
  }, []);

  const buildApiFilters = useCallback(() => {
    const apiFilters = {
      limit: filters.limit,
      offset: filters.offset,
    };

    if (filters.source) {
      apiFilters.source = filters.source;
    }

    if (filters.author) {
      apiFilters.author = filters.author;
    }

    if (filters.dateRange && filters.dateRange !== 'custom') {
      apiFilters.date_range = filters.dateRange;
    }

    if (filters.customStartDate || filters.customEndDate) {
      if (filters.customStartDate) {
        apiFilters.start_date = filters.customStartDate;
      }
      if (filters.customEndDate) {
        apiFilters.end_date = filters.customEndDate;
      }
    }

    return apiFilters;
  }, [filters]);

  return {
    filters,
    updateFilter,
    clearFilters,
    replaceFilters,
    buildApiFilters,
  };
};
